module.exports = __webpack_public_path__ + "static/img/jinfeng.a3699e31.gif";